import { Settings } from '../interfaces/settings';
import { BaseService } from './base.service';
import Client from './client';

export class ReservationService extends BaseService {
  public settings: Settings = settingMock;
  loadSettings(): Promise<Settings> {
    if (this.mockRequest) {
      return new Promise(resovle => {
        setTimeout(() => {
          this.settings = { ...settingMock };
          this.settings.mode = process.env.NODE_ENV;
          resovle(this.settings);
        }, 300);
      });
    }

    return Client.get(`/settings`)
      .then(response => response.data)
      .then(data => {
        this.settings = data;
        return data;
      });
  }

  submitReservation(reservation:any): Promise<void>{
    return Client.post('/reserve', reservation)
      .then(response => response.data)
      .then(data=>{
        if(data.status!=="ok"){
          throw Error(data.message || "Podczas wysyłania wystąpił błąd.");
        }
        return data.data;
      })
      ;
  }
}

const service = new ReservationService();
export default service;

const settingMock: Settings = { maxNumberOfPeople: 10, maxNumberOfRooms: 5 };
